import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderButton = styled(ButtonBase)(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr max-content',
	gridTemplateAreas: '"icon title toggle"',
	alignItems: 'center',
	width: '100%',
	textAlign: 'left',
	borderRadius: 8,
	padding: 0,

	'&:hover': {
		'& .toggle': {
			color: theme.palette.primary.main,
		},
	},

	'&:focus-visible': {
		outline: `1px solid ${theme.palette.primary.main}`,
		outlineOffset: 6,
	},

	'& .icon': {
		gridArea: 'icon',

		'& + .title': {
			marginLeft: 8,
		},
	},

	'& .title': {
		gridArea: 'title',
	},

	'& .toggle': {
		gridArea: 'toggle',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginLeft: 8,
	},
}));

export const Root = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: theme.palette.neutral[0],
	borderRadius: 8,
	padding: 24,

	'& .content': {
		'& .MuiCollapse-wrapperInner': {
			marginTop: 16,
		},
	},
}));
